import { FC, ReactNode, RefObject } from 'react';
import classNames from 'classnames';

interface Props {
    children: ReactNode;
    scrollable?: boolean;
    className?: string;
    ref?: RefObject<HTMLDivElement | null>;
}

const PageContent: FC<Props> = ({ children, scrollable, className, ref }) => {
    return (
        <div
            ref={ref}
            className={classNames('pageContent', className, {
                'pageContent--scrollable': scrollable,
            })}
        >
            {children}
        </div>
    );
};

export default PageContent;
